var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { AllIssuers } from "@trellisconnect/types/dist/src/enums/AllIssuers";
import { ConnectIssuerIcon } from "../IssuerIcon";
import classNames from "classnames";
import { cleanUrl } from "../../lib/util";
import isAAAIssuer from "../../utils/isAAAIssuer";
import useAffiliateConfig from "../../hooks/useAffiliateConfig";
import useFindIssuer from "../../features/configuration/useFindIssuer";
export function FallbackIssuerIcon(_a) {
    var _b = _a.id, id = _b === void 0 ? AllIssuers.OTHER : _b, _c = _a.size, size = _c === void 0 ? "default" : _c;
    var findIssuer = useFindIssuer();
    var issuer = findIssuer(id);
    var isAAA = issuer !== undefined && isAAAIssuer(issuer);
    var backgroundColor = (issuer === null || issuer === void 0 ? void 0 : issuer.color) || (isAAA ? "#da291c" : "#333");
    if (!issuer) {
        return null;
    }
    return (React.createElement("div", { className: classNames("flex aspect-square w-full max-w-[48px] items-center justify-center rounded-full text-center text-2xl font-semibold leading-none text-white", {
            "text-2xl": size === "default",
            "text-[10px]": size === "small",
        }), "data-cy": "issuer-fallback-icon", style: { backgroundColor: backgroundColor, fontFamily: "Arial, sans-serif" } },
        React.createElement("span", null, issuer.name.charAt(0).toUpperCase())));
}
export default function IssuerInfo(_a) {
    var id = _a.id, name = _a.name, site = _a.site, _b = _a.displayLogos, displayLogos = _b === void 0 ? true : _b, insuranceType = _a.insuranceType, rest = __rest(_a, ["id", "name", "site", "displayLogos", "insuranceType"]);
    var hideIssuerLogos = useAffiliateConfig().hideIssuerLogos;
    var Tag = typeof rest.onClick === "function" ? "button" : "div";
    return (React.createElement(Tag, __assign({ className: "b-0 flex w-full items-center bg-transparent p-0 text-left outline-none", id: "tile-".concat(id), "data-testid": "issuer-info" }, rest),
        React.createElement("div", { className: "mr-3 w-12 flex-none" },
            React.createElement(ConnectIssuerIcon, { issuerId: id, fallback: !displayLogos || hideIssuerLogos, insuranceType: insuranceType })),
        React.createElement("div", null,
            React.createElement("h3", { className: "font-semibold leading-none text-black-100" }, name),
            site ? (React.createElement("p", { className: "m-0 font-normal leading-none text-black-300" }, cleanUrl(site))) : null)));
}
